import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import routes from './routes';
import useJumboRoutes from '@jumbo/hooks/useJumboRoutes';
import { logoutUser } from './redux/slice/authSlice';

const AppRoutes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const common = useSelector((state) => state?.common);
  const authUser = useSelector((state) => state?.auth?.loggedUser);

  useEffect(() => {
    if (
      common?.errorMessage === 'Token Expired.' ||
      common?.errorMessage === 'Token not passed.' ||
      common?.errorMessage === 'Invalid token.' ||
      common?.errorMessage === 'Your token has expired!'
    ) {
      dispatch(logoutUser(authUser?._id))
        .unwrap()
        .then((res) => {
          if (res?.status === 200) {
            localStorage.clear();
            navigate('/login');
          }
        });
    }
  }, [common, dispatch, navigate, authUser?._id]);

  const appRoutes = useJumboRoutes(routes);
  return <React.Fragment>{appRoutes}</React.Fragment>;
};
export default AppRoutes;
